import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SaveSlackIntegrationInput_InputAdapter_instanceudbjfe9yrgfb as SaveSlackIntegrationInput_InputAdapter_instance } from '../type/adapter/SaveSlackIntegrationInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveSlackIntegrationMutation_VariablesAdapterClass;
function SaveSlackIntegrationMutation_VariablesAdapter() {
  if (SaveSlackIntegrationMutation_VariablesAdapterClass === VOID) {
    class $ {
      a6h(writer, value, customScalarAdapters, withDefaultValues) {
        writer.v47('input');
        obj(SaveSlackIntegrationInput_InputAdapter_instance).t3z(writer, customScalarAdapters, value.z6g_1);
      }
    }
    initMetadataForObject($, 'SaveSlackIntegrationMutation_VariablesAdapter');
    SaveSlackIntegrationMutation_VariablesAdapterClass = $;
  }
  return SaveSlackIntegrationMutation_VariablesAdapterClass;
}
var SaveSlackIntegrationMutation_VariablesAdapter_instance;
function SaveSlackIntegrationMutation_VariablesAdapter_getInstance() {
  return SaveSlackIntegrationMutation_VariablesAdapter_instance;
}
//region block: init
SaveSlackIntegrationMutation_VariablesAdapter_instance = new (SaveSlackIntegrationMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SaveSlackIntegrationMutation_VariablesAdapter_instance as SaveSlackIntegrationMutation_VariablesAdapter_instancefepbboesbjux,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationMutation_VariablesAdapter.mjs.map
